export default __webpack_public_path__ + "static/media/logo.f2d71c11.png";